import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=3b772007&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&lang=js&"
export * from "./ProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=3b772007&prod&lang=scss&scoped=true&"
import style1 from "./ProductItem.vue?vue&type=style&index=1&id=3b772007&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b772007",
  null
  
)

export default component.exports